import { render, staticRenderFns } from "./AppFormGroupFileUploadComponent.vue?vue&type=template&id=37dd5478&scoped=true&"
import script from "./AppFormGroupFileUploadComponent.ts?vue&type=script&lang=ts&"
export * from "./AppFormGroupFileUploadComponent.ts?vue&type=script&lang=ts&"
import style0 from "./AppFormGroupFileUploadComponent.scss?vue&type=style&index=0&id=37dd5478&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dd5478",
  null
  
)

export default component.exports